import {Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from '@mui/material';

export type ConfirmChangeDialogProps = {
    open: boolean;
    from: string;
    to: string;
    onConfirm: () => void;
    onCancel: () => void;
    /** The confirmed change is being saved: the dialog stays open and can't be dismissed. */
    isSaving?: boolean;
    /** The new value can't be saved (e.g. empty when required): the confirm button is disabled. */
    confirmDisabled?: boolean;
};

/** Asks the user to confirm a text change: "from" → "to". */
export function ConfirmChangeDialog({
                                        open,
                                        from,
                                        to,
                                        onConfirm,
                                        onCancel,
                                        isSaving = false,
                                        confirmDisabled = false,
                                    }: ConfirmChangeDialogProps) {
    return (
        <Dialog open={open} onClose={isSaving ? undefined : onCancel} maxWidth="xs" fullWidth onClick={e => e.stopPropagation()}>
            <DialogTitle>Confirm change</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Do you want to change <Box component="strong" sx={{color: 'text.primary'}}>{from || '(empty)'}</Box>
                    {' '}to <Box component="strong" sx={{color: 'text.primary'}}>{to || '(empty)'}</Box>?
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onCancel} disabled={isSaving}>Cancel</Button>
                <Button variant="contained" onClick={onConfirm} loading={isSaving} disabled={confirmDisabled} autoFocus>
                    Change
                </Button>
            </DialogActions>
        </Dialog>
    );
}
